import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
// import store from '../store'

Vue.use(VueRouter)

const Router = new VueRouter({
  // base: '/',
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

Router.beforeEach((to, from, next) => {
//   if (store.state.language.language && store.state.language.language !== i18n.locale) {
//     i18n.locale = store.state.language.language
//     next()
//   } else if (!store.state.language.language) {
//     store.dispatch('language/setLanguage', navigator.languages)
//       .then(() => {
//         i18n.locale = store.state.language.language
//         next()
//       })
//   } else {
//     next()
//   }
  next()
})

export default Router
